import { Component, Injectable, OnInit, OnChanges, EventEmitter, Output, Input } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatTreeNestedDataSource } from '@angular/material/tree';
import { of as ofObservable, Observable, BehaviorSubject } from 'rxjs';
import { FormControlComponent } from '../form-control.component';
import { ShelfService } from '../../../../../features/spots/services/shelf.service';


interface ShelfNode {
	id?: number;
	name: string;
	selected?: boolean;
	indeterminate?: boolean;
	children?: ShelfNode[];
	parentShelfId?: number;
}

@Component({
	selector: 'wncm-form-control-tree-selection-shelfs',
	templateUrl: 'form-control-tree-selection-shelfs.component.html',
	styleUrls: ['form-control-tree-selection-shelfs.component.scss']
})
export class FormControlTreeSelectionShelfsComponent extends FormControlComponent implements OnInit {
	@Output() sendValue: EventEmitter<any> = new EventEmitter<any>();

	@Output() sendNameOfOneShelf: EventEmitter<any> = new EventEmitter<any>();

	@Input()
	public mediaShelfEdit: any = [];

	@Input()
	public isOnlyOneChoice = false;

	@Input()
	public canSelectOnlyThirdLevel = false;

	treeControl = new NestedTreeControl<ShelfNode>((node) => node.children);
	dataSource = new MatTreeNestedDataSource<ShelfNode>();

	private radioVal: number;

	public expandNodesList: ShelfNode[] = [];

	constructor(public shelf$: ShelfService) {
		super();
		Object.keys(this.dataSource.data).forEach((x) => {
			this.setParent(this.dataSource.data[x], null);
		});
		this.sendValue.emit([]);
	}

	ngOnInit() {
		this.shelf$.getAll().subscribe((data) => {
			const DATA_FROM_SERVICE: ShelfNode[] = [];

			data.items.forEach((levelOne) => {
				const idLevelOne = levelOne.id;
				const nameLevelOne = levelOne.name;
				const childrenLevelOne = levelOne.childShelfs;

				const object = { id: idLevelOne, name: nameLevelOne, children: [], selected: false };

				if (this.mediaShelfEdit.value != null) {
					if (this.mediaShelfEdit.value.includes(idLevelOne)) {
						object.selected = true;
						this.radioVal = idLevelOne;
					}
				}

				if (childrenLevelOne.length > 0) {
					levelOne.childShelfs.forEach((levelTwo) => {
						const idLevelTwo = levelTwo.id;
						const nameLevelTwo = levelTwo.name;
						const childrenLevelTwo = levelTwo.childShelfs;

						const tempObjLevelTwo = {
							id: idLevelTwo,
							name: nameLevelTwo,
							children: [],
							selected: false,
							parentShelfId: idLevelOne
						};
						if (this.mediaShelfEdit.value != null) {
							if (this.mediaShelfEdit.value.includes(idLevelTwo)) {
								this.expandNodesList.push(levelTwo);
								tempObjLevelTwo.selected = true;
								this.radioVal = idLevelTwo;
							}
						}
						object.children.push(tempObjLevelTwo);

						if (childrenLevelTwo.length > 0) {
							levelTwo.childShelfs.forEach((levelThree) => {
								const idlevelThree = levelThree.id;
								const namelevelThree = levelThree.name;

								object.children.forEach((levelTwoChildren) => {
									if (levelTwoChildren.id === levelThree.parentShelfId) {
										const tempObjLevelTwo = {
											id: idlevelThree,
											name: namelevelThree,
											selected: false,
											parentShelfId: idLevelTwo
										};
										if (this.mediaShelfEdit.value != null) {
											if (this.mediaShelfEdit.value.includes(idlevelThree)) {
												this.expandNodesList.push(levelTwoChildren);
												tempObjLevelTwo.selected = true;
												this.radioVal = idlevelThree;
											}
										}
										levelTwoChildren.children.push(tempObjLevelTwo);
									}
								});
							});
						}
					});
				}
				DATA_FROM_SERVICE.push(object);
			});
			this.dataSource.data = DATA_FROM_SERVICE;
			this.treeControl.dataNodes = DATA_FROM_SERVICE;
			this.expandNodesList.forEach((exNode) => {
				this.treeControl.expand(exNode);
				if (exNode.children && exNode.children.length > 0) {
					exNode.children.forEach((exChildNode) => {
						if (exChildNode.selected === true) this.treeControl.expand(exChildNode);
					});
				}
				const childExNode = this.treeControl.dataNodes.find((n) => n.id === exNode.parentShelfId);
				this.treeControl.expand(childExNode);
			});
			this.treeControl.expand(this.treeControl.dataNodes[this.radioVal]);
		});
	}

	hasChild = (_: number, node: ShelfNode) => !!node.children && node.children.length > 0;

	setParent(data, parent) {
		data.parent = parent;
		if (data.children) {
			data.children.forEach((x) => {
				this.setParent(x, data);
			});
		}
	}

	sendShelfName(nodeName: string) {
		this.sendNameOfOneShelf.emit(nodeName);
	}

	clickRadio(event: Event, value: any) {
		event.preventDefault();

		if (!this.radioVal || this.radioVal !== value) {
			this.radioVal = value;
			this.sendValuesOneCheck(this.radioVal);
			return;
		}

		if (this.radioVal === value) {
			this.radioVal = null;
			this.sendValuesOneCheck(this.radioVal);
		}
	}

	isRadioSelected(value: any) {
		return this.radioVal === value;
	}

	todoItemSelectionToggle(checked, node) {
		node.selected = checked;
	}

	sendValuesOneCheck(nodeId: number) {
		this.sendValue.emit([nodeId]);
	}

	removeDuplicates(arr: any[]) {
		return Array.from(new Set(arr));
	}

	sendValues(nodeId: number) {
		if (this.mediaShelfEdit.value == null) this.mediaShelfEdit.value = [];
		if (this.mediaShelfEdit.value.includes(nodeId) === false) {
			this.mediaShelfEdit.value.push(nodeId);
		} else {
			const index = this.mediaShelfEdit.value.indexOf(nodeId);
			if (index > -1) this.mediaShelfEdit.value.splice(index, 1);
		}
		this.sendValue.emit(this.removeDuplicates(this.mediaShelfEdit.value));
	}
}
